import { westNewYorkConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function WestNewYorkPage() {
  return <CityPageTemplate config={westNewYorkConfig} />;
}